import React, { useState, useEffect, useRef } from 'react';
import {
  ThreeSixtyViewContainer,
  ThreeSixtyPauseOverlay,
  ThreeSixtyViewOuterContainer
} from './Styles';

const ThreeSixtyView = ({ threeSixtyViewURL }) => {
  const videoRef = useRef(null);
  const playheadRef = useRef(null);
  const progressRef = useRef(null);
  const timelineRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  const updateProgress = (e) => {
    const video = videoRef.current;
    const timeline = timelineRef.current;
    const playhead = playheadRef.current;
    const progress = progressRef.current;

    const timelineRect = timeline.getBoundingClientRect();
    const timelineOffset = timelineRect.left;
    const timelineWidth = timeline.offsetWidth;
    const playheadWidth = 12;

    // Handle touch events
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;

    let newPlayheadPosition = clientX - timelineOffset;

    if (newPlayheadPosition < 0) {
      newPlayheadPosition = 0;
    } else if (newPlayheadPosition > timelineWidth - playheadWidth) {
      newPlayheadPosition = timelineWidth - playheadWidth;
    }

    const newPlayheadPositionPercentage = newPlayheadPosition / timelineWidth;
    const newVideoTime = video.duration * newPlayheadPositionPercentage;

    video.currentTime = newVideoTime;
    playhead.style.left = `${newPlayheadPosition}px`;
    progress.style.width = `${newPlayheadPositionPercentage * 100}%`;
  };

  const onTimeUpdate = () => {
    if (!isDragging) {
      const video = videoRef.current;
      const timeline = timelineRef.current;
      const playhead = playheadRef.current;
      const progress = progressRef.current;

      const playPercent = (video.currentTime / video.duration) * 100;
      const playheadPosition = (timeline.offsetWidth * playPercent) / 100;

      playhead.style.left = `${playheadPosition}px`;
      progress.style.width = `${playPercent}%`;
    }
  };

  const onInteractionStart = (e) => {
    const video = videoRef.current;
    video.pause();
    setIsDragging(true);
  };

  const onInteractionMove = (e) => {
    if (isDragging) {
      updateProgress(e);
    }
  };

  const onInteractionEnd = () => {
    const video = videoRef.current;
    if (isDragging) {
      video.play();
      setIsDragging(false);
    }
    setIsPaused(false);
  };

  const onTimelineClick = (e) => {
    if (!isDragging) {
      updateProgress(e);
      const video = videoRef.current;
      video.play();
      setIsPaused(false);
    }
  };

  const handleThreeSixtyClick = () => {
    const video = videoRef.current;
    if (isPaused) {
      video.play();
    } else {
      video.pause();
    }
    setIsPaused(!isPaused);
  };

  useEffect(() => {
    const video = videoRef.current;
    const timeline = timelineRef.current;

    video.addEventListener('timeupdate', onTimeUpdate);
    timeline.addEventListener('click', onTimelineClick);

    return () => {
      video.removeEventListener('timeupdate', onTimeUpdate);
      timeline.removeEventListener('click', onTimelineClick);
    };
  }, []);

  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', onInteractionMove);
      document.addEventListener('mouseup', onInteractionEnd);
      document.addEventListener('touchmove', onInteractionMove);
      document.addEventListener('touchend', onInteractionEnd);
    } else {
      document.removeEventListener('mousemove', onInteractionMove);
      document.removeEventListener('mouseup', onInteractionEnd);
      document.removeEventListener('touchmove', onInteractionMove);
      document.removeEventListener('touchend', onInteractionEnd);
    }

    return () => {
      document.removeEventListener('mousemove', onInteractionMove);
      document.removeEventListener('mouseup', onInteractionEnd);
      document.removeEventListener('touchmove', onInteractionMove);
      document.removeEventListener('touchend', onInteractionEnd);
    };
  }, [isDragging]);

  return (
    <ThreeSixtyViewOuterContainer>
      <ThreeSixtyViewContainer>
        {isPaused && (
           <ThreeSixtyPauseOverlay className='video-pause-overlay' onClick={handleThreeSixtyClick}>
            <img
              src="https://www.fmicassets.com/sites/fender.com/themes/img/play.png"
              alt="pause video"
            />
          </ThreeSixtyPauseOverlay>
        )}
        <video
          onClick={handleThreeSixtyClick}
          ref={videoRef}
          id="product-video"
          width="100%"
          loop
          playsInline
          autoPlay
          muted
        >
          <source src={threeSixtyViewURL} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </ThreeSixtyViewContainer>
      <div className="video-controls">
        <div className="timeline" ref={timelineRef}>
          <div className="progress" ref={progressRef}></div>
          <div
            className="playhead"
            ref={playheadRef}
            onMouseDown={onInteractionStart}
            onTouchStart={onInteractionStart}
          >
            <div className="playhead-icon"></div>
          </div>
        </div>
      </div>
    </ThreeSixtyViewOuterContainer>
  );
};

export default ThreeSixtyView;
